import { ColDef } from "ag-grid-community";

const escapeAttr = (text: string) =>
    text.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

/**
 * Подсказка заголовка колонки в стиле страницы. Встроенная headerTooltip рисует подсказку AG Grid
 * со своим видом, а фирменная PlanrTooltip показывает её у любого элемента с data-tip —
 * поэтому кладём атрибут прямо в стандартный шаблон заголовка AG Grid 32.
 */
export const headerTip = (tip?: string): Pick<ColDef, "headerComponentParams"> =>
    tip
        ? {
              headerComponentParams: {
                  template: `<div class="ag-cell-label-container" role="presentation">
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
        <div data-ref="eLabel" class="ag-header-cell-label" role="presentation" data-tip="${escapeAttr(tip)}">
            <span data-ref="eText" class="ag-header-cell-text"></span>
            <span data-ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
            <ag-sort-indicator data-ref="eSortIndicator"></ag-sort-indicator>
        </div>
    </div>`,
              },
          }
        : {};
